import React, { useContext } from 'react';
import InputMask from 'react-input-mask';
import classes from '../Form.module.scss';
import { GeneralContext } from '../../../context/generalContext';

export default function FormInputPhone(props) {
  const { activeLanguage, activeCity } = useContext(GeneralContext);

  return (
    <>
      <InputMask
        {...props.register}
        className={classes.input}
        type='tel'
        mask={activeCity === 6 ? '+\\9\\98 99 999-99-99' : '+7 999 999-99-99'}
        placeholder={activeLanguage === 1 ? 'Телефон' : 'Phone number'}
        autoComplete='off'
        data-has-error={props.errors ? 'true' : 'false'}
        disabled={props.isDisabled}
      />
      <label className={classes.inputLabel}>{activeLanguage === 1 ? 'Телефон' : 'Phone number'}</label>
      <div className={props.isDisabled ? classes.disabled : classes.inputError}>{props.errors && props.errorLabel}</div>
    </>
  );
}
